import { useState } from "react";
import { Link } from "react-router-dom";
import { promotions } from "@/mocks/site";

export default function PromoSection() {
  const [copied, setCopied] = useState<string | null>(null);

  const copy = async (code: string) => {
    try {
      await navigator.clipboard.writeText(code);
    } catch {
      // clipboard may be unavailable; still show feedback for the demo
    }
    setCopied(code);
    window.setTimeout(() => setCopied((c) => (c === code ? null : c)), 1800);
  };

  return (
    <section className="bg-background-100">
      <div className="mx-auto w-full max-w-[1280px] px-4 py-14 md:px-8 md:py-20">
        <div className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <span className="inline-flex items-center gap-2 rounded-full bg-accent-100 px-3.5 py-1.5 text-xs font-bold text-accent-700">
              <i className="ri-coupon-3-line" />
              最新活动
            </span>
            <h2 className="mt-4 font-heading text-2xl font-extrabold text-foreground-950 md:text-4xl">
              领券下单，美味更划算
            </h2>
          </div>
          <p className="text-sm text-foreground-500">优惠码一键复制，下单时填写即可抵扣</p>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-5 md:grid-cols-3">
          {promotions.map((p) => (
            <article
              key={p.code}
              className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition hover:border-primary-300"
            >
              <div className="relative h-44 w-full overflow-hidden bg-background-100">
                <img
                  src={p.image}
                  alt={`${p.title} - 美味的快递优惠活动`}
                  title={`${p.title} - 美味的快递`}
                  className="h-full w-full object-top transition duration-500 group-hover:scale-105"
                />
                <span className="absolute left-3 top-3 rounded-full bg-primary-500 px-3 py-1 text-xs font-bold text-background-50">
                  {p.tag}
                </span>
              </div>
              <div className="flex flex-1 flex-col p-5">
                <h3 className="font-heading text-lg font-bold text-foreground-950">{p.title}</h3>
                <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-500">{p.desc}</p>
                <div className="mt-4 flex items-center gap-3">
                  <button
                    type="button"
                    onClick={() => copy(p.code)}
                    className="flex flex-1 items-center justify-center gap-2 rounded-md border border-dashed border-primary-400 bg-primary-50 px-4 py-2.5 text-sm font-bold tracking-widest text-primary-700 transition hover:bg-primary-100"
                  >
                    <i className={copied === p.code ? "ri-check-line" : "ri-file-copy-line"} />
                    {p.code}
                  </button>
                  <Link
                    to="/food-category"
                    className="flex items-center justify-center gap-1 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 text-sm font-bold text-background-50 transition hover:bg-primary-600"
                  >
                    去使用
                  </Link>
                </div>
              </div>
            </article>
          ))}
        </div>

        {copied && (
          <div className="fixed bottom-8 left-1/2 z-[60] -translate-x-1/2 animate-fade-up rounded-full bg-foreground-950 px-5 py-3 text-sm font-medium text-background-50">
            优惠码「{copied}」已复制，下单时记得使用哦
          </div>
        )}
      </div>
    </section>
  );
}